import React, { useState } from "react";
import { Drawer } from "../../components/Modals";
import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from "flowbite-react";
import TimelineApp from "./Calender";
import { useRoadmapService } from '../../services';
import { useSelector } from "react-redux";

interface ShowSingleRoadmapModalProps {
  setShowModal: (isVisible: boolean) => void;
  isVisible: boolean;
  roadmap_id: string;
}

const ShowSingleRoadmapModal: React.FC<ShowSingleRoadmapModalProps> = ({ 
  setShowModal, 
  isVisible = false, 
  roadmap_id 
}) => {
  const navigate = useNavigate();
  const [viewType, setViewType] = useState("quarter");
  const { fetchSingleRoadmap } = useRoadmapService();
  
  const {
    singleRoadmapLoading,
    singleRoadmapRes = {},
    sim_flag
  } = useSelector((state: any) => state.roadmap);
  
  React.useEffect(() => {
    if (roadmap_id && isVisible) {
      fetchSingleRoadmap(roadmap_id, sim_flag);
    }
  }, [roadmap_id, isVisible, fetchSingleRoadmap, sim_flag]);
  
  const handleProjectClick = (project_id: string) => {
    navigate(`/projects/${project_id}`);
    setShowModal(false);
  };
  
  return (
    <>
      <Drawer
        isOpen={isVisible}
        onClose={() => setShowModal(false)}
        position="right"
        size={72}
      >
        <div className="relative h-[100vh] flex flex-col overflow-hidden">
          <div className="p-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-[#111928]">
            <Breadcrumb className="">
              <Breadcrumb.Item href="/strategicmaps">
                <div className="text-blue-700 text-2xl font-normal">
                  Strategic Maps
                </div>
              </Breadcrumb.Item>
              <Breadcrumb.Item className="">
                <div title={singleRoadmapRes.name} className="text-gray-700 dark:text-white text-xl font-normal truncate max-w-md overflow-hidden first-letter:uppercase">
                  {(!singleRoadmapLoading) ? singleRoadmapRes.name : "Loading ..."}
                </div>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          
          <div className="dark:border-gray-700 sticky top-0 z-[999]">
            <div className={`sticky top-0 z-40 border-gray-200 dark:border-gray-700 flex px-4 py-2 items-center xs:w-full ${sim_flag ? "bg-[#568B77]" : "bg-[#5D99D0]"}`}>
              <div className="mr-auto ml-8">
                <select 
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-slate-800 dark:border-gray-700 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  onChange={(e) => setViewType(e.target.value)}
                  defaultValue={viewType}
                >
                  <option value="week">Weekly View</option>
                  <option value="month">Month View</option>
                  <option value="quarter">Quarter View</option>
                  <option value="year">Yearly View</option>
                </select>
              </div>
            </div>
          </div>
          
          <section className="bg-white dark:bg-[#111928] text-white flex-1 relative px-6 overflow-auto">
            <TimelineApp 
              sim_flag={sim_flag} 
              singleRoadmapRes={singleRoadmapRes} 
              loading={singleRoadmapLoading}
              viewType={viewType}
              handleProjectClick={handleProjectClick}
            />
          </section>
        </div>
      </Drawer>
    </>
  );
};

export default ShowSingleRoadmapModal; 